import React from 'react';
import Container from '../../../containers/integration/apiKeys/showApiKeyContainer';

export default function () {
  return (
    <Container />
  );
}
